export class AnaloguesCard {
	constructor() {
		this.buttons = document.querySelectorAll('.js-box-analogues-icon');
		this.addEventListeners();
	}

	addEventListeners() {
		this.buttons.forEach(button => {
			button.addEventListener('click', () => {
				button.classList.toggle('active');
			});
		});
	}
}

